import React from 'react';
import {IInput} from "interfaces/index";
import {useTranslation} from "react-i18next";
import TextField from "ui/material-kit/TextField";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";
import TextOneMobile from "../customText/texts/TextOne.mobile";
import HeaderOneMobile from "../customText/headers/HeaderOne.mobile";
import HeaderOne from "../customText/headers/HeaderOne";
import {ProjectSettings} from "config";

interface TitleProps {
    title: string
}

export const MobileTitle = (props: TitleProps): JSX.Element => {
    const {title} = props
    return (
        <>
            <MobileTitleText>
                {title}
            </MobileTitleText>
        </>
    )
}

export const Title = (props: TitleProps): JSX.Element => {
    const {title} = props

    return (
        <>
            <TitleText>
                {title}
            </TitleText>
        </>
    )
}

export const LoginInput = (props: any): JSX.Element => {
    const {t} = useTranslation();

    const variant = ProjectSettings.variant()

    const fields = {
        username: t(`common.login.username`),
        mail: t(`common.login.mail`),
        phone: t(`common.login.phone`)
    }

    const placeholder =
        variant === 'lettobet'
            ? `${fields.username}, ${fields.mail.toLowerCase()}`
            : variant === 'goodwin'
                ? `${fields.username}, ${fields.mail.toLowerCase()}, ${fields.phone.toLowerCase()}`
                : `${fields.username}`

    return (
        <>
            <TextField {...props.input} onChange={props.onChange} placeholder={placeholder}
                       id={'login_username_input'} autoComplete={'on'}
                       required/>
        </>
    )
}

interface PasswordProps {
    input: IInput
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}

export const PasswordInput = (props: PasswordProps): JSX.Element => {
    const {t} = useTranslation();

    return (
        <>
            <TextField {...props.input} placeholder={t(`common.login.password`)} type={'password'}
                       inputProps={props.inputProps} autoComplete={'on'}
                       id={'login_password_input'} required/>

        </>
    )
}


interface HelperTextProps {
    text: string,
    linkText: string
    link?: string,
    onClick?: () => void
}

export const HelperText = (props: HelperTextProps): JSX.Element => {
    const {text, link, linkText, onClick} = props

    const navigate = useNavigate();

    return (
        <Wrapper>
            <Text>
                {text}
            </Text>
            <Link onClick={() => {
                if (link) navigate(link)
                if (onClick) onClick()
            }}>
                {linkText}
            </Link>
        </Wrapper>
    )

}

const MobileTitleText = styled(HeaderOneMobile)`
  color: ${({theme}) => theme.palette.color.main};
  text-transform: uppercase;
  margin-bottom: 40px;

  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.palette.background.mobile_title};
`

const TitleText = styled(HeaderOne)`
  color: ${({theme}) => theme.palette.color.main};
  text-transform: uppercase;
  margin-bottom: 65px;
`

const Text = styled(TextOneMobile)`
  color: ${({theme}) => theme.palette.color.main};
  text-align: center;
  min-width: max-content;
`

const Link = styled(TextOneMobile)`
  display: inline-block;
  cursor: pointer;
  color: ${({theme}) => theme.palette.color.link};
  min-width: max-content;
  
`

const Wrapper = styled.div`
  display: flex;
  gap:4px;
`